"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBSV20v2 = exports.handlerApiError = exports.fromByteString = void 0;
/**
 * convert ByteString to utf8 string
 * @param bs ByteString
 * @returns utf8 string
 */
function fromByteString(bs) {
    const encoder = new TextDecoder();
    return encoder.decode(Buffer.from(bs, 'hex'));
}
exports.fromByteString = fromByteString;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function handlerApiError(e) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const message = e.response?.body?.message || e.message;
    throw new Error(message);
}
exports.handlerApiError = handlerApiError;
function isBSV20v2(tick) {
    return /^[a-fA-F0-9]{64}_\d+$/.test(tick);
}
exports.isBSV20v2 = isBSV20v2;
